// extracted by mini-css-extract-plugin
module.exports = {"message":"AriaLive-module__message___X9rsW"};